var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal-edit",attrs:{"title":"Editar Item da estrutura","ok-title":"Salvar","cancel-title":"Cancelar"},on:{"ok":_vm.submit,"close":function($event){_vm.show_form = false}}},[(_vm.show_form)?_c('DadosBasicos',{ref:"dados_basicos"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }